<template>
  <div class="page-container">
    <div class="query-title">酒类销售公司（含子公司、批条酒）各品牌销售情况表</div>

    <div class="content">
      <QueryParams ref="QueryParams" :search-field="searchField" @search="queryData">
        <el-row>
          <el-col>
            <el-form-item>
              <el-radio v-model="radio" label="A">月报分类</el-radio>
              <el-radio v-model="radio" label="B">品牌BQ</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
      </QueryParams>
      <div class="table-container">
        <Table-filter
          title="明细"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
          @confirm="tableConfigConfirm"
        >
          <template #button>
            <table-button name="export" tip="导出" @click="exportExcel" />
          </template>
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="center"
            size="mini"
            show-overflow
            :sort-config="{ multiple: true }"
            :empty-render="{name: 'NotData'}"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :row-class-name="rowClassName"
            @filter-change="filterChangeEvt"
          />
        </Table-filter>
      </div>
    </div>

    <table-custom-filter ref="CustomFilter" :current-filter-field="currentFilterField" @confirm="customeFilter" />

  </div>
</template>

<script>
import { reportForm8 } from '@/api/sap/report'
import tableMixins from '@/utils/tableMixins'
import pageConfig from './config/liquorSalesCompanyReportForms'
import { frontExport, concurrencyReq } from '@/utils/frontExport'
export default {
  mixins: [tableMixins],
  data() {
    return {
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        columns: [],
        data: []
      },
      searchField: {},
      isSetFilter: false,
      radio: 'A'
    }
  },
  watch: {
    radio(nv, ol) {
      if (nv === 'B') {
        const col = {
          field: 'brand_bq',
          title: '品牌(BQ)',
          width: 120,
          type: 'select',
          dictionary: 'A0018'
        }
        const index = this.gridOptions.columns.findIndex(v => v.field === 'ycate_text')
        this.gridOptions.columns.splice(index, 1, { field: 'brand_bq_text', title: '品牌(BQ)', width: 120, filters: [],
          filterMultiple: false })
        this.$refs.QueryParams.replaceCondition('ycate', col)
        this.$refs.xTable.refreshColumn()
      } else {
        const col = {
          field: 'ycate',
          title: '品牌(月报分类)',
          width: 120,
          type: 'select',
          dictionary: 'A0016'
        }
        const index = this.gridOptions.columns.findIndex(v => v.field === 'brand_bq_text')
        this.gridOptions.columns.splice(index, 1, { field: 'ycate_text', title: '品牌(月报分类)', width: 120, filters: [],
          filterMultiple: false })
        this.$refs.QueryParams.replaceCondition('brand_bq', col)
        this.$refs.xTable.refreshColumn()
      }
    }
  },
  created() {
    this.initPage(pageConfig)
  },
  methods: {
    async queryData(page, ranges) {
      if (page === 1) {
        this.pagination.page = page
        if (ranges) {
          // 保存 查询组件的查询参数
          this.ranges = ranges
          this.handleRanges(ranges)
        }
        this.isSetFilter = false
      }
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        ...this.allConditions,
        ...this.pagination,
        is_result: 1,
        sort: this.sortData.concat(this.tableSort),
        radio: this.radio
      }

      this.loading = true
      try {
        const { data, total, calculation, field } = await reportForm8(params)
        if (data.length === 0 && (total - 0)) {
          this.queryData(1, ranges)
          return
        }
        this.pagination.totalCount = total - 0
        this.calculation = this.filtercalculation(calculation)
        // 更新计算值
        this.updateCount()
        if (this.showHeader) {
          this.gridOptions.data = this.tableCountData.concat(data)
        } else {
          this.gridOptions.data = data.concat(this.tableCountData)
        }
        this.allOptions = this.filterAllOptions(field)
        this.setFilter()
      } catch (e) {
        //
      }
      this.loading = false
    },
    // 导出全部 导出本页
    async exportExcel() {
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        radio: this.radio,
        ...this.ranges
      }
      const data = await concurrencyReq(this.pagination.totalCount, params, reportForm8)
      frontExport(this.gridOptions.columns, data, '酒类销售公司（含子公司、批条酒）各品牌销售情况表')
    },
    handleTablePaginationChange(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/report-forms-manage/liquorSalesCompanyReportForms.vue